import { getPromptAnswer } from "@services/alert/alert.service";
import { useCallback, useState, KeyboardEvent, useRef } from "react";
import { Form } from "react-bootstrap";
import styled from 'styled-components';
interface Props {
    value: string;
    onChange: (newValue: string) => any;
    textarea?: boolean;
    emptyPlaceholder?: string;
}

const EditableTextStyles = styled.div`
position: relative;
.editable {
    cursor: pointer;

    &:hover {
        text-decoration: underline;
    }
}

.buttons {
    position: absolute;
    bottom: -35px;
    z-index: 1000;
}

.form-control {
    width: 90%;
}
`

const EditableText = (props: Props) => {
    const onEdit = useCallback(async () => {
        const newValue = await getPromptAnswer('Enter new value', 'Update Value', props.textarea, props.value);
        if (!newValue) {
            return;
        }
        props.onChange(newValue);

        
    }, [props.value, props.textarea, props.onChange]);


    return (
        <EditableTextStyles>
            <div className="hover-control">
                <span onClick={onEdit} className="editable">{props.value || props.emptyPlaceholder || '(None)'}</span>
                <span onClick={onEdit} className="hover-only ms-1">
                    <i className="mdi mdi-pencil"></i>
                </span>
            </div>
        </EditableTextStyles>
    )
}

export default EditableText;